import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import Heading from "components/Heading/Heading";
import SectionHero from "components/SectionHero/SectionHero";

import SectionTextImage from "components/SectionTextImages/SectionTextImage";
import rightImg from "images/about-hero-right.png";
import featureRight from "images/finvue/availablemobile.png";
// images
import { BanknotesIcon, ClipboardDocumentCheckIcon, CreditCardIcon, GlobeAltIcon } from "@heroicons/react/24/outline";
import BottomCTA from "components/CallToAction/BottomCTA";
import FaqSection from "components/FaqSections/FaqSection";
import FinVuePlans from "components/FinvueComponents/FinVuePlans/FinVuePlans";
import GlobalTransactionsSection from "components/services/GlobalTransactionsSection";
import KeyBenefitsSection, { BenefitCard } from "components/services/KeyBenefitsSection";
import invoiceSimplifiedImg from "images/finvue/services/invoice-simplified-bg.jpg";
import payrollSolutionsImg from "images/finvue/services/payment-management.jpg";
import schedulePaymentsImg from "images/finvue/services/schedule-payments-bg.jpg";
import staySecureOnlineImg from "images/finvue/services/stay-secure-online.jpg";
import streamlinedBatchImg from "images/finvue/services/streamlined-batch.jpg";
import servicesBg from "images/new/foreign-exchange-header-bg.png";
import paymentBlockText1 from "images/new/payment-block-text-1.png";
import paymentBlockText2 from "images/new/payment-block-text-2.png";
import paymentsBlockImg1 from "images/new/payments-block-img-1.png";
import paymentsBlockImg2 from "images/new/payments-block-img-2.png";
import oneFeatureCenter from "images/one-section-cards-center.png";
import React from "react";
import SectionFounder from "./SectionFounder";
import SectionStatistic from "./SectionStatistic";
import StatCard from "./StatCard";

import globoIcon from "images/new/icons/globe.svg";

const statistics = [
  { value: "60", label: "Global Customers" },
  { value: "150", label: "Payment Locations" },
  { value: "3", label: "Offices" },
];

const paymentBenefits: BenefitCard[] = [
  {
    id: 1,
    title: "Direct access to UK (Faster, BACS, CHAPS) and EU (SEPA) payments.",
    icon: <BanknotesIcon className="w-8 h-8" />,
  },
  {
    id: 2,
    title: "International payments in 120 countries.",
    icon: <GlobeAltIcon className="w-8 h-8" />,
  },
  {
    id: 3,
    title: "Bulk payment processing for efficiency.",
    icon: <ClipboardDocumentCheckIcon className="w-8 h-8" />,
  },
  {
    id: 4,
    title: "Direct Debit functionality for recurring payments.",
    icon: <CreditCardIcon className="w-8 h-8" />,
  },
];

const PaymentPage = () => {
  return (
    <div className={`nc-PageAbout relative`}>
      {/* ======== BG GLASS ======== */}

      <div className="rounded-b-xl">
        <SectionHero
          centerImg={servicesBg}
          className="rounded-b-xl"
          topHeading={<span className="text-white text-xs">Payment Services</span>}
          heading={
            <span className="text-2xl px-4 md:px-0 font-black lg:text-5xl text-slate-50">
              Say Goodbye to
              <br />
              Payment Headaches
            </span>
          }
          btnTextPrimary="Get started"
          btnPrimaryUrl="/sign-up"
          btnTextSecondary="Contact Sales"
          btnSecondaryUrl="/contact"
          subHeading="We specialise in multi-currency business accounts for efficient cross-border payments."
          subHeadingColor="text-slate-200 px-4"
        />
      </div>

      <section className="relative py-6 md:py-16">
        <GlobalTransactionsSection />
      </section>
      <section className="relative py-6 md:py-0">
        <KeyBenefitsSection title="Payment Services" benefits={paymentBenefits} />
      </section>

      <section className="relative py-6 md:py-16">
        <div className="container">
          <SectionTextImage
            rightImg={paymentBlockText1}
            imageClasses=""
            beforeTitle="Plan smarter"
            title={<h3 className="text-2xl md:text-4xl font-normal">We’ve got you covered</h3>}
            afterTitle="Get added protection from online fraud with virtual debit cards. Perfect for tracking subscriptions and other online payments."
          />
        </div>
      </section>
      <section className="relative py-6 md:py-16">
        <div className="container mx-auto md:max-w-none md:px-0">
          {/* <BackgroundSection /> */}
          <SectionTextImage
            leftImg={paymentBlockText2}
            imageClasses=""
            beforeTitle="Plan smarter"
            title={
              <h3 className="text-2xl md:text-5xl font-bold">
                Payroll Solutions <span className="text-indigo-700 block">for your business.</span>
              </h3>
            }
            afterTitle="We provides a cutting-edge payroll management solution powered by Orenda technology, ensuring seamless and efficient payroll workflows."
            buttonText="Contact us to find out more"
            buttonLink="/contact"
          />
        </div>
      </section>

      <section className="relative ">
        <BottomCTA />
      </section>
      <section>
        <FinVuePlans />
      </section>
    </div>
  );
};

export default PaymentPage;
